import type { ReactNode } from 'react'
import { Menu } from '@systemeio/components'
import { DotsVerticalIcon } from '@systemeio/icons'
import { useTranslation } from 'next-i18next/pages'
import type { TopicInterface } from 'modules/community/types/topic-interface'

interface TopicMenuProps {
  topic: TopicInterface
  onEdit: (topic: TopicInterface) => void
  onDelete: (topicId: number) => void
}

export function TopicMenu({ topic, onEdit, onDelete }: TopicMenuProps): ReactNode {
  const { t } = useTranslation()

  return (
    <div className="relative flex items-center group-hover:visible lg:invisible">
      <Menu
        trigger={
          <span data-testid="topic-menu-trigger" className="flex cursor-pointer items-center">
            <DotsVerticalIcon className="size-5" />
          </span>
        }
        triggerProps={{
          className: 'flex items-center',
        }}
        items={[
          {
            id: 'edit',
            label: t('settings.form.update.label'),
            onSelect: () => {
              onEdit(topic)
            },
          },
          {
            id: 'delete',
            label: t('settings.form.delete.label'),
            onSelect: () => {
              onDelete(topic.id)
            },
          },
        ]}
      />
    </div>
  )
}
